export const HOME_PAGE       = '/';
export const LOGIN_PAGE      = '/signIn';
export const PROFILE_PAGE    = '/profile';
export const RECIPIENTS_PAGE = '/recipients';
export const PREALERTS_PAGE  = '/prealerts';
export const SIGNUP_PAGE     = '/signUp';
export const ACCOUNTSTATUS_PAGE = '/accountStatus';
export const SHIPPING_PAGE = '/shipping';
export const TRACKING_PAGE = '/tracking';